import {
  ACTION_SET_HOTELS_CROSS_SELL_DATA,
  ACTION_SET_VOUCHER_OBJECT,
} from '../NewListing/RailsListingActions';
import { getHotelsList } from '../RIS/PnrStatus/RailInfoAction';
import RailsPdtThankYouHelper from '../../PdtAnalytics/PdtHelper/RailsPdtThankYouHelper';
import { getDataFromAsynStorage } from '../../Utils/RailsConstant';
import { firebaseThankyouTracker } from '../../Analytics/Firebase/util';
import { getCommonPdtData } from '../../PdtAnalytics/PdtHelper/RailsPdtUtils';
export const loadThankYouPage = (bookingDetails, mmtId) => async (dispatch, getState) => {
  const {
    data: {
      bookingStatusDetails,
      priceBreakUp: { totalAmount } = {},
      travellersDetails: { travellerList },
      voucherDetails,
    } = {},
    status,
  } = bookingDetails;
  const data = { bookingData: { bookingStatusDetails, totalAmount, mmtId, bookingStatus: status } };
  dispatch({
    type: ACTION_SET_VOUCHER_OBJECT,
    data: { voucherObject: voucherDetails },
  });

  const fireBaseData = (await getDataFromAsynStorage('fireBaseTrackingData')) ?? {};
  const fireBaseTrackingData = {
    ...fireBaseData,
    extraData: {
      ...fireBaseData.extraData,
      mmtId,
      travelInfo: travellerList,
    },
  };
  firebaseThankyouTracker(fireBaseTrackingData);
  const pdtData = (await getDataFromAsynStorage('pdtDataForThankYou')) ?? {};
  const pdtDataForThankYou = {
    ...pdtData,
    bookingData: {
      ...pdtData.bookingData,
      ...data.bookingData,
    },
  };
  trackPdtThankYouLoad(pdtDataForThankYou);
};

/**
 *
 * Pdt related actions
 *
 */

export const trackPdtThankYouLoad = async (data) => {
  const { bookingData, searchContextData } = data;
  const commonPdt = await getCommonPdtData();
  const pdtData = {
    ...commonPdt,
    bookingData,
    searchContextData,
  };
  RailsPdtThankYouHelper.trackPageLoad(pdtData);
};

const sha256 = async (message) => {
  try {
    // encode as UTF-8
    const msgBuffer = new TextEncoder().encode(message);
    // hash the message
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
    // convert ArrayBuffer to Array
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    // convert bytes to hex string
    const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('exception while encrypting', e);
    return '';
  }
};

/**
 * Push the GTMObject into the Data Layer
 * @param {Object} GTMObject - The GTMObject to push into the Data Layer
 * @param {String} GTMObject.email - The email to hash
 * @param {String} GTMObject.transactionId - The transactionId
 * @param {Number} GTMObject.price - The selling price
 * @param {Number} GTMObject.price_gr - The Gross Revenue
 * @param {Number} GTMObject.price_sp - The discount
 */
export const pushGTMData = async (GTMObject) => {
  try {
    if (!GTMObject?.email) {
      return;
    }
    const hashedEmail = await sha256(GTMObject?.email);
    // Push the hashed email into the Data Layer
    if (hashedEmail) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'hashedEmailReady',
        hashedEmail,
        transaction_id: GTMObject?.transactionId,
        price: GTMObject?.price, // selling price
        price_gr: GTMObject?.price_gr, // Gross Revenue
        price_sp: GTMObject?.price_sp, // discount
      });
    }
  } catch (e) {
    console.error('Error while inserting hashed email into dataLayer', e);
  }
};
